module.exports = __webpack_public_path__ + "55ed9b089e8346d1261f4941a38aadda.svg";